import { db, firebaseauth, User, Role } from "../../../mp-database"
import { eventChain } from "../../../mp-utils/generic-utils/Events/EventChainProvider"
import storage, {
  AUTH_CUSTOM_TOKEN_KEY,
  clearSessionTokens,
  CURRENT_PROGRAM_KEY,
  EOC_CURRENT_PROGRAM_KEY
} from "../../helpers/storage"
import { StorageLabel, Roles } from "../../../mp-utils/generic-utils/Enums"
import { cleanLocalAndSessionStorage } from "../../../mp-utils/generic-utils/common"
import clearUserAssesment from "./assessment"
import { clearLicenses } from "./license"
import hash from "object-hash"
import parseSnapshot from "../../helpers/parseSnapshot"
import { setPreviousSSOSource } from "../../../login/LoggedOutSSO/helpers"
import { SSO_NAME_MAPPING } from "../../../login/LoggedOutSSO/constants"
import { convertToLocalTimezone } from "../../helpers/timezoneConvert"
import { CONTENT_LIBRARY_FILTERS_KEY } from "../../../student-experience/helpers/contentLibraryFiltersStorage"
import {
  FEEDBACK_TIMESTAMP_KEY,
  LAST_USER_INITIATED_FEEDBACK_TIMESTAMP
} from "../../hooks/feedbackConstants"
import { districtAdminCheckOnboarding } from "../../../../services/generic-services/org/districtAdmins/orgDistcrictAdminQueryResolvers"
import { FeedbackSurvey } from "../../../mp-database/contextHelpManager"
import {
  districtAdminSaveOnboarding,
  schoolAdminSaveOnboarding
} from "../../../../services/generic-services/org"
import { schoolAdminCheckOnboarding } from "../../../../services/generic-services/org/schoolAdmins/orgSchoolAdminQueryResolvers"
import { ONBOARDING_SURVEY_DATA } from "../../../user-management/pages/ContextHelpManager/EditAnnouncementsModal/constants"
import {
  DistrictAdminOnboardingCheckRequest,
  DistrictAdminOnboardingSaveRequest,
  SchoolAdminOnboardingCheckRequest,
  SchoolAdminOnboardingSaveRequest
} from "../../../../types/gqlTypes/graphql"
import { removeAllImpersonationKeys } from "../../Impersonation/helpers/impersonationStorageManage"
import { resetMosChat } from "@masteryprep/mp-shared-components/utils"

storage.set(StorageLabel.IS_LOADER, 0)

const AUTH_USER = "AUTH_USER"
const UNAUTH_USER = "UNAUTH_USER"
const FETCHING_USER = "FETCHING_USER"
const FETCHING_USER_FAILURE = "FETCHING_USER_FAILURE"
const FETCHING_USER_SUCCESS = "FETCHING_USER_SUCCESS"
const REMOVE_FETCHING_USER = "REMOVE_FETCHING_USER"
const AUTH_USER_FAILURE = "AUTH_USER_FAILURE"
const SET_USER_DEV_ONLY = "SET_USER_DEV_ONLY"
const U_FETCHING_ALL_USERS = "U_FETCHING_ALL_USERS"
const U_FETCHING_ALL_USERS_SUCCESS = "U_FETCHING_ALL_USERS_SUCCESS"
const U_FETCHING_ALL_USERS_ERROR = "U_FETCHING_ALL_USERS_ERROR"
const U_AUTHING_EDUCATOR = "U_AUTHING_EDUCATOR"
const U_AUTHING_EDUCATOR_SUCCESS = "U_AUTHING_EDUCATOR_SUCCESS"
const U_AUTHING_EDUCATOR_ERROR = "U_AUTHING_EDUCATOR_ERROR"
const U_SET_TEST_USER = "U_SET_TEST_USER"
const U_AUTHING_USER = "U_AUTHING_USER"
const UPDATE_AUTH_USER = "UPDATE_AUTH_USER"
const U_AUTHING_USER_SUCCESS = "U_AUTHING_USER_SUCCESS"
const U_AUTHING_USER_ERROR = "U_AUTHING_USER_ERROR"
const LOGOUT_USER = "LOGOUT_USER"
const LOGOUTSUCCESS = "LOGOUTSUCCESS"
const CHECK_AUTH = "CHECK_AUTH"

const ENABLE_CLASS_DROPDOWN = "ENABLE_CLASS_DROPDOWN"
const ENABLE_TEACHER_DROPDOWN = "ENABLE_TEACHER_DROPDOWN"
const DISABLE_CLASS_DROPDOWN = "DISABLE_CLASS_DROPDOWN"
const DISABLE_TEACHER_DROPDOWN = "DISABLE_TEACHER_DROPDOWN"
const TEACHER_SELECTED_DROPDOWN = "TEACHER_SELECTED_DROPDOWN"
const CLASSES_SELECTED_DROPDOWN = "CLASSES_SELECTED_DROPDOWN"
const STUDENT_SELECTED_DROPDOWN = "STUDENT_SELECTED_DROPDOWN"
const SCHOOL_SELECTED_DROPDOWN = "SCHOOL_SELECTED_DROPDOWN"
const ON_CHECKOUT = "ON_CHECKOUT"
const ON_USER_ONLINE = "ON_USER_ONLINE"
const ON_USER_OFFLINE = "ON_USER_OFFLINE"
const CHANGE_SELECTED_YEAR = "CHANGE_SELECTED_YEAR"
const CHANGE_CONNECT_STATUS = "CHANGE_CONNECT_STATUS"

const FETCHED_DELETED_ACCOUNTS = "FETCHED_DELETED_ACCOUNTS"
const FETCHING_DELETED_ACCOUNTS = "FETCHING_DELETED_ACCOUNTS"
const ERROR_FETCHING_DELETED_ACCOUNTS = "ERROR_FETCHING_DELETED_ACCOUNTS"

const SET_ANNOUNCEMENT = "SET_ANNOUNCEMENT"
const UPDATE_ANNOUNCEMENT = "SET_ANNOUNCEMENT"

const TOGGLE_SHOW_ONBOARDING_SURVEY = "TOGGLE_SHOW_ONBOARDING_SURVEY"

export function fetchDeletedAccounts(collection, sectionId, userRole) {
  return dispatch => {
    const section =
      userRole === Roles.District_Admin ? "schoolDistrict" : "school"
    dispatch({ type: FETCHING_DELETED_ACCOUNTS })
    db.collection(collection)
      .where(section, "==", sectionId)
      .where("deleted", "==", true)
      .onSnapshot(
        querySnapshot => {
          const deletedAccounts = []
          querySnapshot.forEach(doc => {
            if (doc.exists) {
              const data = doc.data()
              deletedAccounts.push(data)
            }
          })
          dispatch({
            type: FETCHED_DELETED_ACCOUNTS,
            payload: { sectionId, collection, deletedAccounts }
          })
        },
        error => {
          dispatch({
            type: ERROR_FETCHING_DELETED_ACCOUNTS,
            error
          })
        }
      )
  }
}

export function changeConnectStatus(status) {
  return {
    type: CHANGE_CONNECT_STATUS,
    value: status
  }
}

export function setConnectStatus(status) {
  return dispatch => dispatch(changeConnectStatus(status))
}

export function onCheckout(pathname) {
  return {
    type: ON_CHECKOUT,
    pathname
  }
}

export function authingUser() {
  return {
    type: U_AUTHING_USER
  }
}

export function checkLogin() {
  return dispatch => {
    // dispatch(fetchingUser())
    return firebaseauth.onAuthStateChanged(user => {
      if (user) {
        // Get the user's ID token result
        user
          .getIdTokenResult()
          .then(idTokenResult => {
            // Access the user's claims
            const claims = idTokenResult.claims

            const localUser = JSON.parse(localStorage.getItem("user"))
            if (
              localUser &&
              (user.uid === localUser.id || user.uid === localUser.uid)
            ) {
              const { role, loginSource, user_id: id } = claims

              dispatch(authingUser())
              db.collection(
                `${role === Roles.Student ? "students" : "educators"}`
              )
                .doc(id)
                .get()
                .then(userDoc => {
                  if (userDoc.exists) {
                    const currentUser = userDoc.data()
                    if (!currentUser.deleted) {
                      eventChain.resetChain()
                      dispatch(
                        authingUserSuccess({
                          ...currentUser,
                          loginSource: loginSource || "unknown"
                        })
                      )
                    } else {
                      return dispatch(logOutAction())
                    }
                  }
                })
                .catch(err => dispatch(authingUserError(err)))
            } else {
              // the authed user doesn't match the localstorage user. Should we logout???
              return dispatch(
                fetchingUserFailure(
                  "authed user doesn't match localstorage user"
                )
              )
            }

            return dispatch(
              fetchingUserSuccess(user.uid, user, user.metadata.lastSignInTime)
            )
          })
          .catch(err => dispatch(authingUserError(err)))
      } else {
        return dispatch(fetchingUserFailure("not logged in"))
      }
    })
  }
}

let tokenInterval = null
export function setTokenRenewTimeout(id_token) {
  const fixSeconds = 20 * 60 * 1000
  if (tokenInterval) {
    clearTimeout(tokenInterval)
  }
  tokenInterval = setInterval(() => {
    generateIdToken()
  }, fixSeconds)
}

export function generateIdToken() {
  firebaseauth.currentUser.getIdToken().then(id_token => {
    storage.set(StorageLabel.API_AUTH_TOKEN_KEY, id_token)
    setTokenRenewTimeout(id_token)
  })
}

export function authingUserSuccess(user) {
  localStorage.setItem(StorageLabel.USER, JSON.stringify(user))
  localStorage.setItem(StorageLabel.USER_TOKEN, hash(user))
  generateIdToken()
  return {
    type: U_AUTHING_USER_SUCCESS,
    user
  }
}

export function authingUserError(error) {
  return {
    type: U_AUTHING_USER_ERROR,
    error
  }
}

export function setTestUser(user) {
  return {
    type: U_SET_TEST_USER,
    user
  }
}

export function authingEducator() {
  return {
    type: U_AUTHING_EDUCATOR
  }
}

export function authingEducatorSuccess(educator) {
  return {
    type: U_AUTHING_EDUCATOR_SUCCESS,
    educator
  }
}

export function authingEducatorError(error) {
  return {
    type: U_AUTHING_EDUCATOR_ERROR,
    error
  }
}

export function authUser(uid) {
  return {
    type: AUTH_USER,
    uid
  }
}

export function unauthUser() {
  return {
    type: UNAUTH_USER
  }
}

export function authUserFailure(error) {
  return {
    type: AUTH_USER_FAILURE,
    error
  }
}

export function logoutUser(error) {
  // unsetCompareMode() // TODO: Might need to create an alternate
}

export function fetchingUser() {
  return {
    type: FETCHING_USER
  }
}

export function fetchingUserFailure(error) {
  console.warn(error)
  return {
    type: FETCHING_USER_FAILURE,
    error: "Error fetching user."
  }
}

export function fetchingUserSuccess(uid, user, timestamp) {
  return {
    type: FETCHING_USER_SUCCESS,
    uid,
    user: {
      ...JSON.parse(JSON.stringify(user)),
      metadata: JSON.parse(JSON.stringify(user.metadata))
    },
    timestamp
  }
}
export function removeFetchingUser() {
  return {
    type: REMOVE_FETCHING_USER
  }
}

export function setUserDevOnly(userId, userEmail, role, activeUser) {
  return {
    type: SET_USER_DEV_ONLY,
    userId,
    userEmail,
    role,
    activeUser
  }
}

export function fetchingAllUsers() {
  return {
    type: U_FETCHING_ALL_USERS
  }
}

export function fetchingAllUsersSuccess(usersList) {
  return {
    type: U_FETCHING_ALL_USERS_SUCCESS,
    usersList
  }
}

export function fetchingAllUsersError(error) {
  return {
    type: U_FETCHING_ALL_USERS_ERROR,
    error
  }
}

export function enableClass(error) {
  return {
    type: ENABLE_CLASS_DROPDOWN,
    error
  }
}

export function enableTeacher(error) {
  return {
    type: ENABLE_TEACHER_DROPDOWN,
    error
  }
}
export function disableClass(error) {
  return {
    type: DISABLE_CLASS_DROPDOWN,
    error
  }
}

export function disableTeacher(error) {
  return {
    type: DISABLE_TEACHER_DROPDOWN,
    error
  }
}

export function selectTeacher(value) {
  return {
    type: TEACHER_SELECTED_DROPDOWN,
    value
  }
}
export function selectStudentOption(value) {
  return {
    type: STUDENT_SELECTED_DROPDOWN,
    value
  }
}
export function selectSchoolOption(value) {
  return {
    type: SCHOOL_SELECTED_DROPDOWN,
    value
  }
}
export function selectClasses(value) {
  return {
    type: CLASSES_SELECTED_DROPDOWN,
    value
  }
}

export function updateLoggedInUser(payload) {
  return {
    type: UPDATE_AUTH_USER,
    payload
  }
}

function handleLogOutSuccess() {
  // unsetCompareMode() // TODO: might need to create an alternate
  return {
    type: UNAUTH_USER
  }
}
function handleLogOutRequest() {
  return {
    type: LOGOUTSUCCESS,
    message: "loading"
  }
}

export function logOutAction(afterLogOutAction?: () => void) {
  return dispatch => {
    resetMosChat()
    firebaseauth.currentUser.getIdTokenResult().then(result => {
      const loginSource = result.claims?.loginSource ?? "unknown"

      if (!!SSO_NAME_MAPPING[loginSource]) {
        setPreviousSSOSource(loginSource)
      }

      return firebaseauth
        .signOut()
        .then(async function () {
          cleanLocalAndSessionStorage({
            localStorageKeys: [
              StorageLabel.USER,
              StorageLabel.NODES,
              StorageLabel.USER_TOKEN,
              StorageLabel.USER_ASSESSMENT,
              StorageLabel.API_AUTH_TOKEN_KEY,
              StorageLabel.STUDY_HALL_Sort_Key,
              StorageLabel.EBOOK_GO_BACK_PAGE,
              AUTH_CUSTOM_TOKEN_KEY,
              FEEDBACK_TIMESTAMP_KEY,
              LAST_USER_INITIATED_FEEDBACK_TIMESTAMP,
              "playerVolume",
              "recommendedAlert",
              "mp_um_table_columns"
            ],
            sessionStorageKeys: [
              CURRENT_PROGRAM_KEY,
              EOC_CURRENT_PROGRAM_KEY,
              CONTENT_LIBRARY_FILTERS_KEY
            ]
          })

          removeAllImpersonationKeys()
          // Pentest finding #2: drop in-memory auth tokens on logout
          clearSessionTokens()

          afterLogOutAction?.()

          // Todo: Farhan & Asad clearing of filters on logout... prolly not needed in new model
          // dispatch(setFiltersData({ filters: {} }))

          dispatch(handleLogOutSuccess())

          //clear userAssesment from store
          dispatch(clearUserAssesment())

          //clear licenses
          dispatch(clearLicenses())

          // ensuring all active firstore listens are closed
          await db.terminate()

          // CHRIS: force a full page refresh--this is brutal but because of how we user firebase app
          // this is the only way to reinit app
          window.location.reload()

          return true
        })
        .catch(function (error) {
          console.log(error)
        })
    })
  }
}

export const selectedYear = schoolYear => dispatch => {
  dispatch({
    type: CHANGE_SELECTED_YEAR,
    schoolYear
  })
}

export const toggleShowOnboardingSurvey = show => dispatch => {
  dispatch({
    type: TOGGLE_SHOW_ONBOARDING_SURVEY,
    show
  })
}

function GetValidUser() {
  let user = null
  const parsedUser = JSON.parse(storage.get(StorageLabel.USER))
  if (storage.get(StorageLabel.USER_TOKEN) === hash(parsedUser))
    user = parsedUser
  return user
}

const localTest = GetValidUser()

interface IAnnoncementDoc {
  startDate: number
  endDate: number
  roles: string[]
  type: string
  category: string
  enabled: boolean
  locations: string[]
  id: string
  frequency: string
}

export function checkAnnouncements(user) {
  return async (dispatch, getState) => {
    const frequencyDuration = {
      HOURLY: 3600000,
      DAILY: 86400000,
      WEEKLY: 604800000
    }

    const currentTimestamp = Date.now()
    const announcementsToShow = []

    const { role = "Global", id } = user ?? {}

    const announcementDocs = await db
      .collection("announcements")
      .where("category", "in", ["announcements", "tips", "help-boxes"])
      .where("enabled", "==", true)
      .where("meta.deleted", "==", false)
      .get()
      .then(docs => {
        const data = Object.values(parseSnapshot(docs)) as IAnnoncementDoc[]
        const feedbackRequestAnnouncement = data.find(
          ann => ann.type === "FEEDBACK_REQUEST"
        )

        return {
          data: data.filter((doc: IAnnoncementDoc) => {
            const isWithinInterval =
              currentTimestamp >= convertToLocalTimezone(doc.startDate) &&
              currentTimestamp <= convertToLocalTimezone(doc.endDate)

            return (
              doc.category === "help-boxes" ||
              (isWithinInterval &&
                (doc.roles?.length === 0 ||
                  doc.roles?.includes(role) ||
                  doc.roles?.includes("Global") ||
                  doc.locations?.includes("Login")))
            )
          }) as IAnnoncementDoc[],
          feedbackRequestAnnouncement
        }
      })
      .catch(error => {
        console.log(error)
        return {
          data: [] as IAnnoncementDoc[],
          feedbackRequestAnnouncement: null
        }
      })
    if (!!announcementDocs?.data?.length) {
      const seenAnnouncements = id ? await getUserAnnouncements(id) : []

      announcementDocs.data.forEach(
        (ann: {
          id: string
          frequency: string
          category: string
          type: string
        }) => {
          const { id, frequency, category } = ann
          if (category === "help-boxes") {
            announcementsToShow.push(ann)

            return
          }

          if (
            frequencyDuration[frequency] &&
            seenAnnouncements?.acknowledged?.[id]?.lastUpdated &&
            seenAnnouncements?.acknowledged?.[id]?.lastUpdated +
              frequencyDuration[frequency] <=
              Date.now()
          ) {
            announcementsToShow.push(ann)
          }

          if (!seenAnnouncements?.acknowledged?.[id]) {
            announcementsToShow.push(ann)
          }
        }
      )
    }
    // NOTE: Commented out, because currently Super Admin, ACT Admin can have not only `help-boxes`
    // For roles not in roleDistribution (like Super Admin, ACT Admin, etc),we still need to dispatch the help articles
    // const helpArticleBoxesToDispatch = announcementsToShow.filter(
    //   announcement => announcement.category === "help-boxes"
    // )

    //check onboarding
    const state = getState()
    const roleDistribution: Record<
      string,
      (
        data:
          | DistrictAdminOnboardingCheckRequest
          | SchoolAdminOnboardingCheckRequest
      ) => Promise<boolean>
    > = {
      [Roles.District_Admin]: districtAdminCheckOnboarding,
      [Roles.School_Admin]: schoolAdminCheckOnboarding
    }

    // If role is not in roleDistribution (Teacher, Super Admin, etc),
    // dispatch all announcements and return (no onboarding for these roles)
    if (!roleDistribution[role]) {
      dispatch({
        type: SET_ANNOUNCEMENT,
        payload: announcementsToShow
      })
      return
    }

    let onboarding = undefined
    if (state.users.showOnboarding === undefined) {
      onboarding = await roleDistribution[role]({
        id: user.id
      })
    } else {
      onboarding = state.users.showOnboarding
    }
    if (onboarding && announcementDocs?.feedbackRequestAnnouncement?.enabled) {
      announcementsToShow.push({
        ...ONBOARDING_SURVEY_DATA,
        ...announcementDocs?.feedbackRequestAnnouncement,
        message: announcementDocs?.feedbackRequestAnnouncement.message
      })
    }
    //eof check onboarding

    dispatch({
      type: SET_ANNOUNCEMENT,
      payload: announcementsToShow
    })

    dispatch({
      type: TOGGLE_SHOW_ONBOARDING_SURVEY,
      payload: onboarding
    })
  }
}

export function updateAnnouncements(user, activeAnnouncement) {
  return async (dispatch, getState) => {
    try {
      const announcements = getState()?.users?.announcements || []
      const seenAnnouncements = await getUserAnnouncements(user?.id)
      const { id } = activeAnnouncement

      if (user?.id) {
        await db
          .collection("announcements_users")
          .doc(user?.id)
          .set(
            {
              acknowledged: {
                [id]: {
                  lastUpdated: Date.now()
                }
              }
            },
            { merge: true }
          )
      } else {
        if (!seenAnnouncements.acknowledged) {
          seenAnnouncements.acknowledged = {}
        }
        // update local user
        seenAnnouncements.acknowledged[id] = { lastUpdated: Date.now() }
        localStorage.setItem("announcements", JSON.stringify(seenAnnouncements))
      }

      dispatch({
        type: SET_ANNOUNCEMENT,
        payload: announcements.filter(ann => ann.id !== activeAnnouncement.id)
      })
    } catch (error) {
      console.log(error)
    }
  }
}

async function getUserAnnouncements(id) {
  if (id) {
    return await db
      .collection("announcements_users")
      .doc(id)
      .get()
      .then(doc => doc.data() || {})
  } else {
    //for Global user eg.. user not logged in
    return JSON.parse(localStorage.getItem("announcements_users") || "{}")
  }
}

export function saveFeedbackSurvey(fb: FeedbackSurvey, user: User) {
  const { rating, feedback } = fb
  const { role } = user

  const roleDistribution: Record<
    string,
    (
      data?:
        | DistrictAdminOnboardingSaveRequest
        | SchoolAdminOnboardingSaveRequest
    ) => Promise<any>
  > = {
    [Roles.District_Admin]: districtAdminSaveOnboarding,
    [Roles.School_Admin]: schoolAdminSaveOnboarding
  }

  if (!roleDistribution[role]) {
    return null
  }

  return async (dispatch, getState) => {
    try {
      await roleDistribution[role]({
        id: user.id,
        rating,
        feedback
      })

      const announcements = getState()?.users?.announcements || []

      dispatch({
        type: SET_ANNOUNCEMENT,
        payload: announcements.filter(ann => ann.id !== "announcement_survey")
      })
      dispatch({
        type: TOGGLE_SHOW_ONBOARDING_SURVEY,
        payload: false
      })
    } catch (err) {
      console.error({ err })
    }
  }
}

const initialUserState = {
  online: true,
  authUser: null,
  testUser: localTest || null,
  lastUpdated: 0,
  uid: "",
  email: "",
  role: null,
  isAuthed: undefined,
  isFetching: false,
  error: "",
  notFound: false,
  isFetchingAllUsers: false,
  usersList: null,
  activeUser: null,
  isAuthingEducator: false,
  isAuthingEducatorError: "",
  educator: null,
  isAuthing: false,
  isAuthingError: "",
  is_teacher_enable: false,
  is_class_enable: false,
  classes_selected_value: null,
  teacher_selected_value: null,
  student_selected_value: null,
  school_selected_value: null,
  customToken: "",
  checkuser: null,
  checkout: false,
  checkoutlocation: null,
  selectedYear: "",
  connected: false,
  verifyEmailSent: false,
  deletedAccounts: {
    students: {},
    educators: {}
  },
  announcements: [],
  showOnboarding: undefined
}

export function users(state = initialUserState, action) {
  switch (action.type) {
    case CHANGE_CONNECT_STATUS:
      return {
        ...state,
        connected: action.value
      }
    case ON_USER_ONLINE: {
      return {
        ...state,
        online: true
      }
    }
    case ON_USER_OFFLINE: {
      return {
        ...state,
        online: false
      }
    }
    case ON_CHECKOUT:
      return {
        ...state,
        checkout: true,
        checkoutlocation: action.pathname
      }

    case U_AUTHING_USER:
      return {
        ...state,
        isAuthing: true
      }
    case U_AUTHING_USER_SUCCESS:
      return {
        ...state,
        testUser: action.user,
        isAuthed: true,
        isAuthing: false,
        checkout: false,
        checkoutlocation: null
      }
    case U_AUTHING_USER_ERROR:
      return {
        ...state,
        isAuthingError: action.error,
        isAuthing: false
      }
    case U_SET_TEST_USER:
      return {
        ...state,
        testUser: state.checkuser
      }
    case U_AUTHING_EDUCATOR:
      return {
        ...state,
        isAuthingEducator: true
      }
    case U_AUTHING_EDUCATOR_SUCCESS:
      return {
        ...state,
        isAuthingEducator: false,
        isAuthed: true,
        educator: action.educator
      }
    case U_AUTHING_EDUCATOR_ERROR:
      return {
        ...state,
        isAuthingEducator: false,
        isAuthingEducatorError: action.error
      }
    case AUTH_USER:
      return {
        ...state,
        isAuthed: true,
        uid: action.uid,
        lastUpdated: new Date(),
        isFetching: false,
        checkout: false,
        checkoutlocation: null
      }
    case UNAUTH_USER:
      return {
        ...state,
        isAuthed: false,
        isFetching: false,
        authedId: "",
        checkuser: null,
        selectedYear: ""
      }
    case LOGOUT_USER:
      return {
        ...state,
        isAuthed: false
      }
    case AUTH_USER_FAILURE:
      return {
        ...state,
        lastUpdated: 0,
        uid: "",
        email: "",
        role: null,
        isAuthed: false,
        isFetching: false,
        error: action.error,
        notFound: true
      }
    case FETCHING_USER:
      return {
        ...state,
        isFetching: true
      }
    case FETCHING_USER_FAILURE:
      return {
        ...state,
        isFetching: false,
        isAuthed: false,
        error: action.error,
        notFound: true,
        testUser: null
      }
    case REMOVE_FETCHING_USER:
      return {
        ...state,
        isFetching: false
      }
    case FETCHING_USER_SUCCESS:
      return action.user === null
        ? {
            ...state,
            isFetching: false,
            error: "",
            testUser: state.checkuser
          }
        : {
            ...state,
            isFetching: false,
            error: "",
            lastUpdated: action.timestamp,
            authUser: action.user,
            uid: action.uid,
            email: action.user.email,
            role: action.user.role,
            notFound: false,
            isAuthed: true
          }
    case SET_USER_DEV_ONLY:
      return {
        ...state,
        uid: action.userId,
        email: action.userEmail,
        role: action.role,
        activeUser: action.activeUser
      }
    case U_FETCHING_ALL_USERS:
      return {
        ...state,
        isFetchingAllUsers: true
      }
    case U_FETCHING_ALL_USERS_SUCCESS:
      return {
        ...state,
        isFetchingAllUsers: false,
        usersList: action.usersList
      }
    case U_FETCHING_ALL_USERS_ERROR:
      return {
        ...state,
        isFetchingAllUsers: false,
        error: action.error
      }
    case ENABLE_CLASS_DROPDOWN:
      return {
        ...state,
        is_class_enable: true,
        error: action.error
      }
    case ENABLE_TEACHER_DROPDOWN:
      return {
        ...state,
        is_teacher_enable: true,
        error: action.error
      }
    case DISABLE_CLASS_DROPDOWN:
      return {
        ...state,
        is_class_enable: false,
        error: action.error
      }
    case DISABLE_TEACHER_DROPDOWN:
      return {
        ...state,
        is_teacher_enable: false,
        error: action.error
      }
    case TEACHER_SELECTED_DROPDOWN:
      return {
        ...state,
        teacher_selected_value: action.value
      }
    case CLASSES_SELECTED_DROPDOWN:
      return {
        ...state,
        classes_selected_value: action.value
      }
    case STUDENT_SELECTED_DROPDOWN:
      return {
        ...state,
        student_selected_value: action.value
      }
    case SCHOOL_SELECTED_DROPDOWN:
      return {
        ...state,
        school_selected_value: action.value
      }
    case LOGOUTSUCCESS:
      return {
        ...state
      }
    case CHANGE_SELECTED_YEAR:
      return {
        ...state,
        selectedYear: action.schoolYear
      }
    case UPDATE_AUTH_USER:
      return Object.assign({}, state, action.payload)
    case "UPDATE_STUDENT_ASSESSMENT_RECORD":
      localStorage.setItem("user", JSON.stringify(action.student))
      localStorage.setItem("user_token", hash(action.student))
      return {
        ...state,
        testUser: {
          ...state.testUser,
          assessments: {
            ...action.student.assessments
          }
        }
      }
    case FETCHED_DELETED_ACCOUNTS: {
      const deletedAccounts = { ...state.deletedAccounts }
      deletedAccounts[action.payload.collection][action.payload.sectionId] =
        action.payload.deletedAccounts
      return {
        ...state,
        deletedAccounts
      }
    }
    case SET_ANNOUNCEMENT:
      action.payload?.sort((a, b) => a.priority - b.priority)
      return {
        ...state,
        announcements: action.payload
      }

    case TOGGLE_SHOW_ONBOARDING_SURVEY:
      return {
        ...state,
        showOnboarding: action.payload
      }
    default:
      return state
  }
}
